import type { EventType, WorkMode } from "./types";

export type AttendanceIntentKey = "check-in" | "check-out" | "field-work";

export type AttendanceIntent = {
  key: AttendanceIntentKey;
  eventType: EventType;
  workMode: WorkMode;
  label: string;
  description: string;
};

const intents: Record<AttendanceIntentKey, AttendanceIntent> = {
  "check-in": {
    key: "check-in",
    eventType: "CHECK_IN",
    workMode: "OFFICE",
    label: "ลงเวลาเข้า",
    description: "ตรวจสอบ GPS และยืนยันเวลาเข้าด้วยเวลาเซิร์ฟเวอร์",
  },
  "check-out": {
    key: "check-out",
    eventType: "CHECK_OUT",
    workMode: "OFFICE",
    label: "ลงเวลาออก",
    description: "ตรวจสอบ GPS และยืนยันเวลาออกด้วยเวลาเซิร์ฟเวอร์",
  },
  "field-work": {
    key: "field-work",
    eventType: "FIELD_WORK",
    workMode: "FIELD",
    label: "ลงพื้นที่ / Field Work",
    description: "ตรวจสอบ GPS แล้วระบุประเภทงานก่อนบันทึก",
  },
};

export function parseAttendanceIntent(search: string): AttendanceIntent | null {
  const key = new URLSearchParams(search).get("action");
  if (!key || !Object.hasOwn(intents, key)) return null;
  return intents[key as AttendanceIntentKey];
}
